var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',[(_vm.formdata.d.length > 0)?_c('waterfall',{attrs:{"column":2,"dataList":_vm.formdata.d},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var info = ref.info;
var idx = ref.idx;
var colIdx = ref.colIdx;
return [_c('v-uni-view',{class:'col-' + colIdx + ' masonryHalfImg newHalfImg ' + (idx===0?'mt0':'')},[_c('type-halfImg',{attrs:{"formdata":info,"idx":idx}})],1)]}}],null,false,262730130)}):_vm._e()],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }